module.exports = __webpack_public_path__ + "static/media/house-icon.75e9e59b.svg";